import React, { Suspense } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import Health from './containers/Health';
import { zestRoutes } from './Routes';

const calculator = React.lazy(() => import('./containers/calculator/calculator'));
function App() {
  return (
    <div className='App'>
      <Suspense fallback={<div>....loading</div>}>
        <Switch>
          <Route exact path={zestRoutes.calculator} component={calculator} />
          <Route exact path={zestRoutes.calculator_v1} component={calculator} />
          <Route exact path={zestRoutes.health} component={Health} />
          <Redirect to={zestRoutes.calculator} />
        </Switch>
      </Suspense>
    </div>
  );
}

export default App;
